import { collection, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes } from "firebase/storage";
import { db, storage, FIREBASE_READY, STORAGE_READY } from "../firebase";

export const MAX_FILE_BYTES = 10 * 1024 * 1024; // must match storage.rules
export const ACCEPTED_FILE_TYPES = ".pdf,.doc,.docx,.jpg,.jpeg,.png";

/**
 * Uploads any attached files to Storage under `${storageFolder}/{docId}/...`
 * then writes the submission to Firestore. Matches firestore.rules'
 * isNewSubmission() check (status:"new" + serverTimestamp submittedAt).
 */
export async function submitForm({ collectionName, storageFolder, fields, files = [] }) {
  if (!FIREBASE_READY) {
    throw new Error("This service isn't configured yet. Please try again shortly, or contact us directly.");
  }

  const docRef = doc(collection(db, collectionName));
  const documentPaths = [];

  if (files.length && STORAGE_READY) {
    for (const file of files) {
      const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
      const path = `${storageFolder}/${docRef.id}/${Date.now()}_${safeName}`;
      await uploadBytes(ref(storage, path), file, { contentType: file.type || "application/octet-stream" });
      documentPaths.push(path);
    }
  }

  await setDoc(docRef, {
    ...fields,
    documentPaths,
    status: "new",
    submittedAt: serverTimestamp(),
  });

  return docRef.id;
}
